/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByConversationCustomAggregateKind =
  (typeof GroupByConversationCustomAggregateKind)[keyof typeof GroupByConversationCustomAggregateKind];

export const GroupByConversationCustomAggregateKind = {
  conversation_custom_aggregate: 'conversation_custom_aggregate',
} as const;
